module.exports = __webpack_public_path__ + "img/LCRG_Swords_05.ca37e605.png";